import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json'; // English bundled eagerly — it's the default

const LOCALE_KEY    = 'trustify_locale';
const SUPPORTED     = ['en', 'fr', 'de'];
const savedLocale   = localStorage.getItem(LOCALE_KEY);
const browserLang   = navigator.language?.slice(0, 2);
const initialLang   =
  (savedLocale && SUPPORTED.includes(savedLocale)) ? savedLocale
  : (SUPPORTED.includes(browserLang) ? browserLang : 'en');

// Lazily fetch a non-English locale bundle (separate webpack chunk each)
function loadLocale(lng) {
  if (lng === 'fr') return import(/* webpackChunkName: "i18n-fr" */ './fr.json');
  if (lng === 'de') return import(/* webpackChunkName: "i18n-de" */ './de.json');
  return Promise.resolve({ default: en });
}

async function addBundle(lng) {
  if (i18n.hasResourceBundle(lng, 'translation')) return;
  const mod = await loadLocale(lng);
  i18n.addResourceBundle(lng, 'translation', mod.default, true, false);
}

i18n
  .use(initReactI18next)
  .init({
    resources:     { en: { translation: en } },
    lng:           'en',          // always start with English (bundle is ready)
    fallbackLng:   'en',
    interpolation: { escapeValue: false },
  });

// If user prefers a non-English locale, load its bundle then switch
if (initialLang !== 'en') {
  addBundle(initialLang).then(() => i18n.changeLanguage(initialLang));
}

// Persist locale changes; lazy-load bundle when switching language
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LOCALE_KEY, lng);
  if (lng !== 'en') addBundle(lng); // preload for next render cycle
});

export default i18n;
